/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { bem } from "../shared/BEM";

/**
 * Component props
 */
export interface ILoadingProps {
	size: "xs";
}

/**
 * Loading component
 *
 * @param props Component props
 */
export function Loading(props: ILoadingProps) {

	const style = bem("loading").mod(["size-" + props.size]);

	return <div className={style.className()}>
		<div className={style.el("outer").className()}>
			<div className={style.el("wrap").className()}>
				<div className={style.el("spinner").className()}>
					<div className={style.el("clipper").mod(["left"]).className()}>
						<div className={style.el("clipper-circle").mod(["left"]).className()}></div>
					</div>
					<div className={style.el("patch").className()}>
						<div className={style.el("patch-circle").className()}></div>
					</div>
					<div className={style.el("clipper").mod(["right"]).className()}>
						<div className={style.el("clipper-circle").mod(["right"]).className()}></div>
					</div>
				</div>
			</div>
		</div>
	</div>;

}
